export var CHANGE_THEME = 'CHANGE_THEME';



// WEBPACK FOOTER //
// ./src/actions/theme.js